module.exports = __webpack_public_path__ + "img/personal-information.svg";